import { createSlice } from "@reduxjs/toolkit";

const initialState: {
  hostname: string;
} = {
  hostname: "",
};

export const hostnameSlice = createSlice({
  name: "hostname",
  initialState,
  reducers: {
    setHostname: (state, action: { payload: string }) => {
      state.hostname = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setHostname } = hostnameSlice.actions;

export default hostnameSlice.reducer;
